export default "__VITE_ASSET__CmfdEZc___"